export default class Scrolly {
  constructor(element) {
    this.element = element;
    this.options = {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0,
    };
    this.init();
  }

  init() {
    this.observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );

    const items = this.element.querySelectorAll('[data-scrolly]');

    setTimeout(() => {
      items.forEach((item) => {
        this.observer.observe(item);
      });
    }, 50);
  }

  watch(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        this.observer.unobserve(entry.target);
      }
    });
  }
}